<script setup>
// Imports
import FormGenerator from 'src/generators/formGenerator.vue'

// Constants
const countryOptions = {
  field: 'country',
  valueKey: 'alpha2',
  labelKey: 'country',
  translateKeyBase: 'Shared.Globals.Countries',
  translateKey: 'alpha3',
  avatar: true,
  avatarValuePrefix: 'fi fi-',
  avatarValue: 'alpha2',
}

// Component props
const props = defineProps({
  schema: {
    type: [Object, null],
    required: true,
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emits = defineEmits(['newFormData', 'cancelForm'])

// Models
const contact = defineModel({ type: Object, required: true })
const validationErrors = defineModel('validationErrors', { type: Object, required: true })

// Refs
const contactData = ref({})

watch(
  () => contact.value,
  (newValue) => {},
  {
    immediate: true,
  },
)
</script>

<template>
  <div>
    <form-generator
      v-model="contact"
      v-model:form-errors="validationErrors"
      :fields="['companyName']"
      :nested="false"
      items-service="contacts"
      :schema="schema"
    ></form-generator>

    <div class="row">
      <div class="col-12">
        <form-generator
          v-model="contact"
          v-model:form-errors="validationErrors"
          :fields="['jobTitle']"
          :nested="false"
          items-service="contacts"
          :schema="schema"
        ></form-generator>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <form-generator
          v-model="contact"
          v-model:form-errors="validationErrors"
          :fields="['firstName']"
          :nested="false"
          items-service="contacts"
          :schema="schema"
        ></form-generator>
      </div>
      <div class="col-6 q-pl-md">
        <form-generator
          v-model="contact"
          v-model:form-errors="validationErrors"
          :fields="['lastName']"
          :nested="false"
          items-service="contacts"
          :schema="schema"
        ></form-generator>
      </div>
    </div>

    <form-generator
      v-model="contact"
      v-model:form-errors="validationErrors"
      :fields="['email']"
      :nested="false"
      items-service="contacts"
      :schema="schema"
    ></form-generator>

    <form-generator
      v-model="contact"
      v-model:form-errors="validationErrors"
      :fields="['tel']"
      :nested="false"
      items-service="contacts"
      :schema="schema"
    ></form-generator>

    <form-generator
      v-model="contact"
      v-model:form-errors="validationErrors"
      :fields="['street']"
      :nested="false"
      items-service="contacts"
      :schema="schema"
    ></form-generator>

    <div class="row">
      <div class="col-6">
        <form-generator
          v-model="contact"
          v-model:form-errors="validationErrors"
          :fields="['houseNumber']"
          :nested="false"
          items-service="contacts"
          :schema="schema"
        ></form-generator>
      </div>
      <div class="col-6 q-pl-md">
        <form-generator
          v-model="contact"
          v-model:form-errors="validationErrors"
          :fields="['houseNumberSuffix']"
          :nested="false"
          items-service="contacts"
          :schema="schema"
        ></form-generator>
      </div>
    </div>

    <form-generator
      v-model="contact"
      v-model:form-errors="validationErrors"
      :fields="['postalCode']"
      :nested="false"
      items-service="contacts"
      :schema="schema"
    ></form-generator>

    <form-generator
      v-model="contact"
      v-model:form-errors="validationErrors"
      :fields="['city']"
      :nested="false"
      items-service="contacts"
      :schema="schema"
    ></form-generator>

    <form-generator
      v-model="contact"
      v-model:form-errors="validationErrors"
      :fields="['state']"
      :nested="false"
      items-service="contacts"
      :schema="schema"
    ></form-generator>

    <form-generator
      v-model="contact"
      v-model:form-errors="validationErrors"
      :fields="['country']"
      :nested="false"
      items-service="contacts"
      :schema="schema"
      :options-config="countryOptions"
    ></form-generator>
  </div>

  <div class="flex justify-center q-mt-md q-mb-md">
    <q-btn :loading="loading" :label="$t('Shared.Globals.Save')" color="primary" @click="emits('newFormData', contact)" />
    <q-btn :label="$t('Shared.Globals.Cancel')" color="negative" class="q-ml-sm" @click="emits('cancelForm')" />
  </div>
</template>

<style scoped></style>
